export default __webpack_public_path__ + "static/logo-39921d0a28051a2943ba25b1a92e1035.png";